__turbopack_context__.v({
  "fadein": "toast-module-scss-module__5UQiuq__fadein",
  "fadeout": "toast-module-scss-module__5UQiuq__fadeout",
  "toast": "toast-module-scss-module__5UQiuq__toast",
  "toast--error": "toast-module-scss-module__5UQiuq__toast--error",
  "toast--info": "toast-module-scss-module__5UQiuq__toast--info",
  "toast--success": "toast-module-scss-module__5UQiuq__toast--success",
  "toast--without-close-button": "toast-module-scss-module__5UQiuq__toast--without-close-button",
  "toast__actions-container": "toast-module-scss-module__5UQiuq__toast__actions-container",
  "toast__close-button": "toast-module-scss-module__5UQiuq__toast__close-button",
  "toast__icon": "toast-module-scss-module__5UQiuq__toast__icon",
  "toast__message": "toast-module-scss-module__5UQiuq__toast__message",
  "toast__separator": "toast-module-scss-module__5UQiuq__toast__separator",
});
